import * as React from 'react';
import SvgIcon from '../../SvgIcon';
const SvgHidden = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M2.46 10.35a20 20 0 0 1-2.25-3L2.2 6Q6 12.35 12 12.35T21.78 6l2 1.36a19.5 19.5 0 0 1-2.22 3L23.17 12l.83.83-1.66 1.67-.82-.83-1.7-1.67a12.3 12.3 0 0 1-3.28 1.92l.63 2.38.31 1.14-2.27.56-.3-1.14-.63-2.35a13 13 0 0 1-2.28.19 13 13 0 0 1-2.44-.22l-.63 2.38-.3 1.14-2.27-.61.31-1.14.65-2.43A12.7 12.7 0 0 1 4.17 12l-1.69 1.7-.82.83L0 12.82.83 12Z"
    }));
export default SvgHidden;
